module.exports = __webpack_public_path__ + "img/Pickup.dbf5851a.png";